import { defineComponent as _defineComponent } from 'vue'
import { useMp4Encoder } from "./composables/useMp4Encoder";
import { useGifDecoder } from "./composables/useGifDecoder";
import GifUpload from "./components/GifUpload.vue";
import { ref, shallowRef } from "vue";
import GifEncoding from "./components/GifEncoding.vue";
import GifFooter from "./components/GifFooter.vue";
import VideoPreview from "./components/VideoPreview.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const encoding = ref(false);
const progress = ref(0);
const video = shallowRef<string>();

const convertFileToVideo = async (file: File) => {
  const gifDecoder = useGifDecoder(file);

  const { frames, width, height, frameRate } = await gifDecoder.getFrames();

  const mp4Encoder = useMp4Encoder({ width, height, frameRate });

  await mp4Encoder.initialize();

  for (const frame of frames) {
    await mp4Encoder.addFrame(frame);
  }

  const buffer = mp4Encoder.finish();
  video.value = URL.createObjectURL(new Blob([buffer], { type: "video/mp4" }));
};

const onImageUpload = async (file: File) => {
  progress.value = 0;
  encoding.value = true;

  try {
    await convertFileToVideo(file);
  } finally {
    encoding.value = false;
  }
};

const reset = () => {
  video.value = undefined;
};

return { __sfc: true,encoding, progress, video, convertFileToVideo, onImageUpload, reset, GifUpload, GifEncoding, GifFooter, VideoPreview }
}

})